import { request } from "@umijs/max";
import { ITemplateGroup } from "./robot";

export enum ConsumptionType {
  FIRST = "FIRST",
  RENEW = "RENEW",
  RECHARGE = "RECHARGE",
}

export enum GoodsInfoRobotTemplateDurationEnum {
  YEAR = "YEAR",
  MONTH = "MONTH",
}

export interface IGoodsInfo {
  /** 价格 */
  amount: number;
  /** 折扣价格 */
  discountAmount?: number;
  description: string;
  goodsId: string;
  goodsName: string;
  nums: number;
  orderDetailName: string;
  resourceNums: number;
  timeUnit: GoodsInfoRobotTemplateDurationEnum;
}

export interface IResource {
  amount: number;
  description: string;
  endTime: string;
  name: string;
  resourceId: string;
  avatar: string;
  nums: number;
  amountInfo: Record<string, { amount: number; unit: string }>;
}

export enum ResourceType {
  /** 动能值 */
  COMPUTE_POWER = "COMPUTE_POWER",
  ROBOT_TEMPLATE = "ROBOT_TEMPLATE",
  ENTERPRISE_WECHAT_SEAT = "ENTERPRISE_WECHAT_SEAT",
}

export interface IResourceMeta {
  goodsList: Partial<IGoodsInfo>[];
  resourceList: Partial<IResource>[];
  resourceType: ResourceType;
}

/**
 * @deprecated 新改接口
 * @param consumptionType
 * @returns
 */
export function getOrderTemplateService(consumptionType: ConsumptionType) {
  return request<API.BaseResponse<{ typeGoodsList: IResourceMeta[] }>>(
    "/api/damselfish-fee-center/orderInfo/goodsList",
    {
      method: "POST",
      data: {
        consumptionType,
      },
    }
  );
}

/**
 * 获取席位购买列表
 * @returns
 */
export function postOrderSeatGoodsService(consumptionType: ConsumptionType) {
  return request<API.BaseResponse<Partial<IGoodsInfo>[]>>(
    "/api/damselfish-fee-center/orderInfo/goodsList/v2",
    {
      method: "POST",
      data: {
        consumptionType,
        resourceType: ResourceType.ENTERPRISE_WECHAT_SEAT,
      },
    }
  );
}

/**
 * 获取机器人模板列表
 */
export function postOrderRobotTemplatesGoodsService(
  consumptionType: ConsumptionType
) {
  return request<API.BaseResponse<ITemplateGroup[]>>(
    "/api/damselfish-fee-center/orderInfo/goodsList/template",
    {
      method: "POST",
      data: {
        consumptionType,
      },
    }
  );
}

/**
 * 获取机器人模板时长列表
 * @returns
 */
export function postOrderRobotTemplatesGoodsDurationsService(
  consumptionType: ConsumptionType
) {
  return request<API.BaseResponse<Partial<IGoodsInfo>[]>>(
    "/api/damselfish-fee-center/orderInfo/goodsList/v2",
    {
      method: "POST",
      data: {
        consumptionType,
        resourceType: ResourceType.ROBOT_TEMPLATE,
      },
    }
  );
}

/**
 * 获取购买动能值的商品列表
 */
export function postBuyOrderPowerGoodsListService() {
  return request<API.BaseResponse<Partial<IGoodsInfo>[]>>(
    "/api/damselfish-fee-center/orderInfo/goodsList/v2",
    {
      method: "POST",
      data: {
        consumptionType: ConsumptionType.FIRST,
        resourceType: ResourceType.COMPUTE_POWER,
      },
    }
  );
}

/**
 * 获取动能值购买资格
 * @returns
 */
export function postCanUsePowerDiscountService() {
  return request<API.BaseResponse<boolean>>(
    "/api/damselfish-fee-center/orderInfo/goodsList/canUse",
    {
      method: "POST",
      data: {
        resourceType: ResourceType.COMPUTE_POWER,
      },
    }
  );
}

export enum BillType {
  PREPAY = "PREPAY",
  POST_PAY = "POST_PAY",
}
export enum OrderSource {
  USER = "USER",
  SYSTEM_FEE = "SYSTEM_FEE",
  SYSTEM_CENTRAL = "SYSTEM_CENTRAL",
  USER_POST_PAY = "USER_POST_PAY",
}
export interface ICreateOrderDto {
  billType: BillType;
  consumptionType: ConsumptionType;
  orderSource: OrderSource;
  tenantId: string;
  typeGoodsList: Partial<IResourceMeta>[];
  userId: string;
}
export interface OrderInfo {
  orderId: string;
  amount: number;
}
export function upgradeOrRechargeService(dto: Partial<ICreateOrderDto>) {
  return request<API.BaseResponse<OrderInfo>>(
    "/api/damselfish-fee-center/orderInfo/createOrder/upgradeOrRecharge",
    {
      method: "POST",
      data: dto,
    }
  );
}

export type Balance = {
  cashBalance: number;
  depositBalance: number;
  giftBalance: number;
  level: "PERSON" | "ORG";
  totalBalance: number;
  unclearedAmount: number;
  canUseBalance: number;
};
export function getBalanceService() {
  return request<API.BaseResponse<Balance>>(
    "/api/damselfish-fee-center/userSearch/userBalanceInfo"
  );
}

export enum PayType {
  OFFLINE = "OFFLINE",
  BALANCE = "BALANCE",
  WECHAT = "WECHAT",
  ALIPAY = "ALIPAY",
}
export type RequestPayDto = {
  orderId: string;
  payType: PayType;
  verCode: string;
  returnUrl?: string;
  qrcodeSize: number;
};
export enum PayStatus {
  WAIT = "WAIT",
  PAYING = "PAYING",
  DONE = "DONE",
  REJECT = "REJECT",
  CANCEL = "CANCEL",
}
export type PayResult = {
  payId: string;
  payStatus: PayStatus;
  codeUrl: string;
  expireTime: number;
};
export function requestPayService(dto: Partial<RequestPayDto>) {
  return request<API.BaseResponse<PayResult>>(
    "/api/damselfish-fee-center/payInfo/requestPay",
    {
      method: "POST",
      data: dto,
    }
  );
}
export enum ChangeType {
  RECHARGE = "RECHARGE",
  CONSUME = "CONSUME",
  WITHDRAW = "WITHDRAW",
}
export function getVerCodeService(data: {
  businessId: string;
  changeType: ChangeType;
}) {
  return request<API.BaseResponse>(
    "/api/damselfish-fee-center/payInfo/getVerCode",
    {
      method: "POST",
      data,
    }
  );
}

export type IServiceOrderDto = {
  seatNum: number;
  seatIds: string[];
  seatDuration: { id: string; amount: number };

  power: { amount: number; id: string };
  powerNum: number;

  consumptionType: ConsumptionType;
};

/**
 * 计算价格接口
 * @description 动能值新版本不需要这玩意儿参与计算
 * @param data
 * @returns
 */
export function calcAmountService(data: Partial<IServiceOrderDto>) {
  return request<API.BaseResponse<{ amount: number }>>(
    "/api/damselfish-fee-center/orderInfo/orderConfirm",
    {
      method: "POST",
      data,
    }
  );
}

export function createOrderService(data: Partial<IServiceOrderDto>) {
  return request<API.BaseResponse<OrderInfo>>(
    "/api/damselfish-fee-center/orderInfo/createOrder",
    {
      method: "POST",
      data,
    }
  );
}

export function getPayCallbackService(params: { payId: string }) {
  return request<API.BaseResponse<PayStatus>>(
    "/api/damselfish-fee-center/payInfo/getPayStatus",
    {
      params,
    }
  );
}
